import {AbstractService} from 'services/AbstractService';

const PROJECT_GROUP_URL = '/api/projects/{0}/optimization/balancing';
const PROJECT_BALANCING_METRICS_URL = '/api/projects/{0}/optimization/balancing/metrics';

export class BalancingService extends AbstractService {

  async getProjectGroup (accountId, projectId) {
    return await this.client.get(
      PROJECT_GROUP_URL.format(projectId),
      {},
      {accountId}
    );
  }

  async updateProjectGroup (accountId, projectId, groupData) {
    return await this.client.put(
      PROJECT_GROUP_URL.format(projectId),
      groupData,
      {accountId}
    );
  }

  async getProjectMetrics (accountId, projectId) {
    return await this.client.get(
      PROJECT_BALANCING_METRICS_URL.format(projectId),
      {},
      {accountId}
    );
  }

}
